import type { Handler } from './handler';
import type {
  ApiSmarticoProfileEventParams,
  ApiSmarticoProfileEventPort,
} from './ports/api-smartico-profile-event.port';
import { resolveAdapter } from '~/adapters/registry';

type Params = ApiSmarticoProfileEventParams;

type Ports = { apiSmarticoProfileEvent: ApiSmarticoProfileEventPort };

type Result = Promise<void>;

export const registerSmarticoProfileEventHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiSmarticoProfileEvent: resolveAdapter('apiSmarticoProfileEvent'),
  },
) => {
  await ports.apiSmarticoProfileEvent.handle(params);
};
